import createIcon from '../../createIcon';

/**
 * @component @name WarningAmber
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNi40OUwxOS41MyAxOS41SDQuNDdMMTIgNi40OVpNMTIgMi41TDEgMjEuNUgyM0wxMiAyLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgMTYuNUgxMVYxOC41SDEzVjE2LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgMTAuNUgxMVYxNS41SDEzVjEwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WarningAmber = createIcon('WarningAmber', [
  ['path', { d: 'M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5Z', key: '139sou' }],
  ['path', { d: 'M13 16.5H11V18.5H13V16.5Z', key: '1j2b1n' }],
  ['path', { d: 'M13 10.5H11V15.5H13V10.5Z', key: '1rlppe' }],
]);

export default WarningAmber;
